import {Locale} from './types/common';

// common config for all widgets
export const MOBILE_BREAKPOINT = 768;
export const DEFAULT_LOCALE: Locale = 'fi';
export const LOCALES: Locale[] = ['fi', 'sv', 'en'];

/**
 * service names for endpoint configuration
 */
export const SERVICE_DEFAULT = '_default';
export const SERVICE_PROFILE_NEW = 'profile-new';
export const SERVICE_JOBPOSTING = 'jobposting';
export const SERVICE_CODES = 'codes';
export const SERVICE_KOPA = 'kopa';
export const SERVICE_SKILL_RECOMMENDATION = 'skillrecommendation';
export const SERVICE_JOBSEARCH = 'jobsearch';
export const SERVICE_JOBPOSTING_WATCH = 'jobpostingwatch';
export const SERVICE_PROFILESEARCH = 'profilesearch';
export const SERVICE_OTV = 'OTV';
export const SERVICE_ASSIGNMENTS = 'assignments';
export const SERVICE_EMPLOYMENT_SUPPORT_SERVICE = 'employmentsupportservice';
export const SERVICE_ETT = 'ett';
export const SERVICE_EMPLOYMENT_SUPPORT_SERVICE_TRANSLATIONS =
  'employmentsupportservicetranslations';
export const SERVICE_AGGREGATION = 'aggregation';
export const SERVICE_FAVORITES = 'favorites';
export const SERVICE_USERSERVICE = 'userservice';
export const BUSINESS_PLANNER = 'businessplanner';
export const SERVICE_YRITYSYHTEYDENOTTO = 'yritysyhteydenotto';
export const SERVICE_PUBLIC_COMPANY_PROFILE = 'publiccompanyprofile';

/**
 * default locations for TMT api service endpoints used in widgets
 */
export const DEFAULT_API_PATHS = {
  [SERVICE_DEFAULT]: '/api/v1', // Use the old endpoint as default... for now.
  [SERVICE_PROFILE_NEW]: '/api/profile-new/v1',
  [SERVICE_JOBPOSTING]: '/api/jobposting/v1',
  [SERVICE_CODES]: '/api/codes/v1/koodistot',
  [SERVICE_KOPA]: '/api/codes/v1/kopa',
  [SERVICE_JOBSEARCH]: '/api/jobpostingfulltext/search/v1',
  [SERVICE_JOBPOSTING_WATCH]: '/api/jobpostingfulltext/watch/v1',
  [SERVICE_PROFILESEARCH]: '/api/profilefulltext/search/v1',
  [SERVICE_SKILL_RECOMMENDATION]: '/hakupalvelu/api/1.0/skillrecommendation',
  [SERVICE_OTV]: '/userservice/api/otv/v1',
  [SERVICE_ASSIGNMENTS]: '/userservice/api/assignments/v1',
  [SERVICE_EMPLOYMENT_SUPPORT_SERVICE]: '/userservice/api/ess/v1',
  [SERVICE_ETT]: '/userservice/api/ett/v1',
  [SERVICE_EMPLOYMENT_SUPPORT_SERVICE_TRANSLATIONS]: '/.rest/localization/v2',
  [SERVICE_AGGREGATION]: '/api/aggregation/v1',
  [SERVICE_FAVORITES]: '/api/favorites/v1',
  [SERVICE_USERSERVICE]: '/userservice/api/v2',
  [BUSINESS_PLANNER]: '/api/businessplanner/v1/',
  [SERVICE_YRITYSYHTEYDENOTTO]: '/userservice/api/yritysyhteydenotto/v1',
  [SERVICE_PUBLIC_COMPANY_PROFILE]: '/api/jobposting/v1'
};
